<template>
	<div v-if="device=='pc'">
		<box :customer="true" :ref="boxRef" title="请选择" :width="1000" :index="0" moduleName="moduleName" @hide="hide"
			@submit="submit" :store="store" selectType="checkbox" @boxdataload="boxdataload" />		
	</div>
	<div v-else>
		<phonebox :customer="true" :ref="boxRef" title="请选择" :width="1000" :index="0" moduleName="moduleName" @hide="hide"
			@submit="submit" :store="store" selectType="checkbox" @boxdataload="boxdataload" />
	</div>
</template>	
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			customerid: {
				default: () => {
					return null
				}
			},
			
			
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					buttons:[],
					columns: [{
						field: 'parentordercode',
						title: '父单编码',	
						// render:"$input"
					},{
						field: 'ordercode',
						title: '订单编码',	
						// render:"$input"
					},{
						field: 'shop',
						title: '收款店铺',
						formatter:'store',
						// editRender: {
						// 	type: '$emun',
						// 	props: {
						// 		name: 'store'
						// 	},
						// 	events: {
						
						// 	}
						// },
					},{
						field: 'needamount',
						title: '应收款',
					},{
						field: 'ordershop',
						title: '订单来源店铺',
						formatter:'store',
					},{
						field: 'trade_create_time',
						title: '下单时间',
						span:8,
						render:'$datePicker'
					},{
						field: 'skcode',
						title: '收款单'
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: false,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				// console.log(page, form, other)
				return new Promise((resolve) => {
					// let data = []
					// resolve({list:data})
					this.$api.collection.listTradesnew({
						mode: 'box',
						index: this.index,
						customerid:this.customerid,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						resolve({list:[]})
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>